import { bindEvents } from '../../../assets/js/helpers';

import CursorTrailing from '../trailing/script';

const selector = 'cursor-expand';

export default class CursorExpand {

	constructor(section) {
		this.el = {
			section
		};

		// bind events to class scope
		this.events = bindEvents(this);

		// class variable groups

		// class variables
		this.cursorTrailing = null;

		// engage
		this.init();
	}

	static get selector() {
		return selector;
	}

	// initialize class

	init() {
		if (!this.el.section.classList.contains('is-contained')) {
			this.addEventListeners();
		}
	}

	// initialize from controller

	start() {
		this.addEventListeners();
	}

	// event listeners

	addEventListeners() {
		this.cursorTrailing = new CursorTrailing(this.el.section);

		if (this.el.section.classList.contains('is-contained')) {
			this.cursorTrailing.start();
		}
	}

	removeEventListeners() {
		if (this.cursorTrailing) {
			this.cursorTrailing.destroy();
		}
	}

	// toggle expanded state

	toggle() {
		if (this.el.section.classList.contains('is-active')) {
			this.collapse();
		} else {
			this.expand();
		}
	}

	expand() {
		this.el.section.classList.add('is-active');
	}

	collapse() {
		this.el.section.classList.remove('is-active');
	}

	// move to specific oordinates

	moveTo(x, y) {
		if (this.cursorTrailing) {
			this.cursorTrailing.moveTo(x, y);
		}
	}

	// slow down

	slow() {
		if (this.cursorTrailing) {
			this.cursorTrailing.slow();
		}
	}

	// destroy

	destroy() {
		this.removeEventListeners();
	}

	// getters

	get offset() {
		if (this.cursorTrailing) {
			return this.cursorTrailing.offset;
		}
		return null;
	}

}
